import React, { SetStateAction } from "react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
interface Props {
  label?: string;
  placeholder?: string;
  type: string;
  value: string;
  setValue: React.Dispatch<SetStateAction<string>>;
  readOnly?: boolean;
  capitalize?: boolean;
}
function TextInput({
  label,
  placeholder,
  type,
  value,
  setValue,
  readOnly,
  capitalize,
}: Props) {
  return (
    <div className="flex flex-col gap-2 w-full">
      <Label>{label}</Label>
      <Input
        placeholder={placeholder}
        type={type}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        readOnly={readOnly ?? false}
        onInput={
          capitalize
            ? (e) => {
                const target = e.target as HTMLInputElement;
                target.value = target.value.toUpperCase();
              }
            : undefined
        }
      />
    </div>
  );
}

export default TextInput;
